import { render, staticRenderFns } from "./AssignmentRights.vue?vue&type=template&id=61335dfd"
import script from "./AssignmentRights.vue?vue&type=script&lang=js"
export * from "./AssignmentRights.vue?vue&type=script&lang=js"
import style0 from "./AssignmentRights.vue?vue&type=style&index=0&id=61335dfd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports